import { useMemo } from 'react';
import { useSearchParams } from 'react-router';

import { useLatest } from 'hooks/useLatest';

export function useSearchFacetSelectedValues(filterType: string) {
  const [searchParams] = useSearchParams();

  const selectedValues = useMemo(
    () => searchParams.getAll(filterType) || [],
    [filterType, searchParams],
  );

  const selectedValuesRef = useLatest(selectedValues);

  return selectedValuesRef.current;
}
